export default "__VITE_ASSET__Dzm1tpmq__"